<div class="dialog">
  <umss-dialog-header title="Citation Details" (onClose)="onClose()" />

  @if (isLoading) {
    <div class="content">
      <div class="skeleton-container">
        <!-- Row 1: Status + Reported date -->
        <div class="skeleton-row">
          <div class="skeleton-col">
            <div class="skeleton-label animate-pulse"></div>
            <div class="skeleton-badge animate-pulse"></div>
          </div>
          <div class="skeleton-col">
            <div class="skeleton-label animate-pulse"></div>
            <div class="skeleton-value animate-pulse"></div>
          </div>
        </div>

        <!-- Row 2: Facility + Reported by -->
        <div class="skeleton-row">
          <div class="skeleton-col">
            <div class="skeleton-label animate-pulse"></div>
            <div class="skeleton-value animate-pulse"></div>
            <div class="skeleton-value-small animate-pulse"></div>
          </div>
          <div class="skeleton-col">
            <div class="skeleton-label animate-pulse"></div>
            <div class="skeleton-value animate-pulse"></div>
            <div class="skeleton-value-small animate-pulse"></div>
          </div>
        </div>

        <!-- Form fields -->
        <div class="skeleton-field">
          <div class="skeleton-label animate-pulse"></div>
          <div class="skeleton-input animate-pulse"></div>
        </div>

        <div class="skeleton-field">
          <div class="skeleton-label animate-pulse"></div>
          <div class="skeleton-textarea animate-pulse"></div>
        </div>

        <div class="skeleton-field">
          <div class="skeleton-label animate-pulse"></div>
          <div class="skeleton-textarea animate-pulse"></div>
        </div>
      </div>
    </div>
  } @else if (citation) {
    <div class="content">
      <div class="metadata">
        <!-- Row 1: Status + Reported date -->
        <div class="metadata-row">
          <div class="metadata-col">
            <span class="metadata-label">Status</span>

            @if (citation.status) {
              <umss-citation-status-badge [status]="citation.status" />
            }
          </div>

          <div class="metadata-col">
            <span class="metadata-label">Reported date</span>

            <span class="metadata-value">
              {{ citation.reportedDate | date: 'MM/dd/yyyy' }}
            </span>
          </div>
        </div>

        <!-- Row 2: Facility + Reported by -->
        <div class="metadata-row">
          <div class="metadata-col">
            <span class="metadata-label">Facility</span>

            <div class="metadata-value">
              <span> {{ citation.facilityName }} </span>

              <span class="metadata-value">
                {{ citation.facilityAddress }}
              </span>
            </div>
          </div>

          <div class="metadata-col">
            <span class="metadata-label">Reported by</span>

            <div class="metadata-value">
              <span> {{ citation.reportedBy }} </span>

              <span> {{ citation.reportedByPosition }} </span>
            </div>
          </div>
        </div>

        @if (mode === 'edit') {
          @if (form) {
            <form class="metadata">
              <umss-vertical-field label="Title">
                <umss-input [formControl]="form.controls.title" />
              </umss-vertical-field>

              <umss-vertical-field label="Issue">
                <umss-textarea [formControl]="form.controls.issue" />
              </umss-vertical-field>

              <umss-vertical-field label="Required steps or training">
                <umss-textarea
                  [formControl]="form.controls.requiredStepOrTraining"
                />
              </umss-vertical-field>
            </form>
          }
        } @else if (mode === 'view') {
          <div class="metadata-field">
            <span class="metadata-label">Title</span>
            <span class="metadata-value"> {{ citation.title }} </span>
          </div>

          <div class="metadata-field">
            <span class="metadata-label">Issue</span>
            <span class="metadata-value"> {{ citation.issue }} </span>
          </div>

          <div class="metadata-field">
            <span class="metadata-label">Required steps or training</span>
            <span class="metadata-value">
              {{ citation.requiredStepOrTraining }}
            </span>
          </div>
        }
      </div>
    </div>

    <!-- Actions -->
    @if (mode === 'edit') {
      <umss-dialog-footer
        tertiaryButtonLabel="Cancel"
        tertiaryButtonVariant="Secondary"
        [secondaryButtonLabel]="showResolveButton ? 'Mark as resolved' : null"
        secondaryButtonVariant="Secondary"
        primaryButtonLabel="Save changes"
        primaryButtonVariant="Primary"
        (onTertiaryClick)="onCancel()"
        (onSecondaryClick)="onMarkAsResolved()"
        (onPrimaryClick)="onSave()"
      />
    } @else if (mode === 'view') {
      <umss-dialog-footer
        primaryButtonLabel="Close"
        primaryButtonVariant="Primary"
        [secondaryButtonLabel]="showResolveButton ? 'Mark as resolved' : null"
        secondaryButtonVariant="Secondary"
        (onPrimaryClick)="onClose()"
        (onSecondaryClick)="onMarkAsResolved()"
      />
    }
  }
</div>

@if (showResolveConfirmDialog) {
  <umss-alert-dialog
    title="Mark as resolved"
    message="Are you sure you want to mark this citation as resolved? This action cannot be undone."
    primaryButtonLabel="Mark as resolved"
    primaryButtonVariant="Primary"
    secondaryButtonLabel="Cancel"
    [open]="showResolveConfirmDialog"
    (onPrimaryClick)="confirmResolve()"
    (onSecondaryClick)="cancelResolve()"
    (onClose)="cancelResolve()"
  />
}
